// ─── Feuille : CHOIX D'UN LIEU (emplacement) ──────────────────────
// Liste les lieux du calendrier ; renvoie { id, nom, adresse } ou null
// (« Aucun ») via onSelect. Modale SŒUR (jamais imbriquée dans une autre).
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Feuille, useUI, useT } from '@mop/core';

export default function FeuilleChoixLieu({ visible, lieux = [], valeurId, onSelect, onFermer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const choisir = (l) => { onSelect?.(l); onFermer?.(); };
  return (
    <Feuille visible={visible} titre={t('lieux.choisir')} emoji="📍"
      hauteur={lieux.length > 4 ? 0.6 : 0.38} onFermer={onFermer}>
      {lieux.length === 0 ? (
        <Text style={s.vide}>{t('lieux.aucunAide')}</Text>
      ) : (
        <>
          <TouchableOpacity style={s.item} onPress={() => choisir(null)}>
            <Text style={{ fontSize: 16 }}>∅</Text>
            <Text style={[s.itemTxt, { color: UI.muted }]}>{t('lieux.aucun')}</Text>
          </TouchableOpacity>
          {lieux.map(l => (
            <TouchableOpacity key={l.id} style={s.item} onPress={() => choisir(l)}>
              <Text style={{ fontSize: 16 }}>📍</Text>
              <View style={{ flex: 1 }}>
                <Text style={[s.itemTxt, valeurId === l.id && { color: UI.accent, fontWeight: '800' }]} numberOfLines={1}>{l.nom}</Text>
                {!!l.adresse && <Text style={s.itemSous} numberOfLines={1}>{l.adresse}</Text>}
              </View>
            </TouchableOpacity>
          ))}
        </>
      )}
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  vide: { fontSize: 13.5, color: UI.faint, lineHeight: 19, paddingVertical: 10 },
  item: { flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 11, borderBottomWidth: 0.5, borderBottomColor: UI.border },
  itemTxt: { fontSize: 14, color: UI.ink },
  itemSous: { fontSize: 12, color: UI.faint, marginTop: 1 },
});
